import React from "react";
import { useQuickSightKPI  } from "@/hooks/useKpiReports";

const QuickSightAwsKpiDashboard = () => {
  const { embedUrl } = useQuickSightKPI();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsKpiDashboard;
